import React from 'react';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import { i18n } from 'config/locales';
import { ForeignBusinessConferencesContactsItemModel } from 'forms/sections/foreign/business/conferences/types';
import Field from 'components/Form/Field/Field';
import Textarea from 'components/Form/Textarea';

interface Props
  extends ValidationElementProps,
    Partial<ForeignBusinessConferencesContactsItemModel> {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
}

export default class ConferenceContactsItem extends ValidationElement<Props> {
  update = (queue: Partial<ForeignBusinessConferencesContactsItemModel>) => {
    this.props.onUpdate({
      Explanation: this.props.Explanation,
      ...queue,
    });
  };

  updateExplanation = (value: ForeignBusinessConferencesContactsItemModel['Explanation']) => {
    this.update({
      Explanation: value,
    });
  };

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;
    return (
      <Field
        title={i18n.t('foreign.business.conferences.heading.explanation')}
        titleSize="label"
        help="foreign.business.conferences.help.explanation"
        scrollIntoView={this.props.scrollIntoView}
        attribute={`${attribute}.Explanation`}
      >
        <Textarea
          name="Explanation"
          className="conferences-explanation"
          bind
          required={this.props.required}
          {...this.props.Explanation}
          onUpdate={this.updateExplanation}
          attribute={`${attribute}.Explanation`}
        />
      </Field>
    );
  }
}

ConferenceContactsItem.defaultProps = {
  name: 'ContactsItem',
  Explanation: {},
  onUpdate: () => {},
  onError: (value, arr) => arr,
};
